/** @jsxImportSource @emotion/react */
import { useContext } from 'react'
import {
  Box,
  Display,
  Heading1,
  JustifyContent,
  FlexDirection,
  Visible,
  AlignItems,
  Space,
} from '@gousto-internal/citrus-react'
import { store } from '../../store'
import { getFirstName } from '../../selectors/user'
import { SearchBox } from '../SearchBox'
import { Hero } from '../Hero'

type HelpHeroProps = {
  onSearchMobileToggle: (isOn: boolean) => void,
  isMobileSearchResultVisible: boolean
}

const HelpHero = ({ onSearchMobileToggle, isMobileSearchResultVisible }: HelpHeroProps) => {
  const { state } = useContext(store)
  const firstName = getFirstName(state)
  const message = `Hi${firstName ? ` ${firstName}` : ''}, how can we help?`

  return (
    <Hero paddingH={[0, 6]}>
      <Box
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, FlexDirection.Column, FlexDirection.Row]}
        justifyContent={JustifyContent.SpaceBetween}
        alignItems={AlignItems.Baseline}
      >
        <Visible display={[Display.None, Display.Block]}>
          <Heading1 size={[5, 6, 7]}>
            {message}
          </Heading1>
          <Space size={[0, 3, 0]} />
        </Visible>
        <Box
          width="100%"
          maxWidth={['100%', '24rem']}
        >
          <SearchBox
            onSearchMobileToggle={onSearchMobileToggle}
            isMobileSearchResultVisible={isMobileSearchResultVisible}
          />
        </Box>
      </Box>
    </Hero>
  )
}

export { HelpHero }
